import { render, staticRenderFns } from "./InputElement.vue?vue&type=template&id=5b0857b0&functional=true&lang=pug&"
import script from "./InputElement.vue?vue&type=script&lang=js&"
export * from "./InputElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports